/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomSpinner.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description This a custom Spinner/Loader Dialog box -> It will open whenever an API call made and close automatically
 */
import { Box, Dialog } from "@mui/material";
import React from "react";

function CustomLoaderDialog(props) {
  return (
    <Dialog open={props.open}>
      <Box
        sx={{
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "25px",
        }}
      >

        <img
          style={{
            height: "150px",
            width: "200px",
            padding: "-20px",

            borderRadius: "10px",
          }}
          src={require("../../assets/gif-files/logogif.gif")}
          alt="loading..."
        />
      </Box>
    </Dialog>
  );
}

export default CustomLoaderDialog;
